import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchImpcsOfSingleOperator = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcsOfSingleOperator',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
    queryStringParams: {
      operatorCode: payload.params.operatorCode,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchImpcsOfSingleOperator;
